import React from "react";
import {
  ArrayField,
  Datagrid,
  FunctionField,
  ShowProps,
  TextField,
  UrlField,
} from "react-admin";
import { Chip, Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import CustomLabeled from "components/layout/CustomLabeled";

const Summary = (props: ShowProps) => {
  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Bus Assistant Detail
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Name">
            <TextField source="fullName" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Nric/Fin">
            <TextField source="nric" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Date of Birth">
            <CustomDateField source="dateOfBirth" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Gender">
            <TextField source="gender" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Race">
            <TextField source="race" emptyText="-" />
          </CustomLabeled>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Nationality">
            <TextField source="nationality" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <FunctionField
            render={(record: any) => (
              <CustomLabeled name="Background Check">
                {record.backgroundChecks &&
                record.backgroundChecks.length > 0 ? (
                  <div>
                    {record.backgroundChecks.map(
                      (backgroundCheck: IBackgroundCheck, index: number) => (
                        <span key={backgroundCheck.id}>
                          <Chip label={backgroundCheck.name} />
                          {index < record.backgroundChecks.length - 1 && " "}
                        </span>
                      ),
                    )}
                  </div>
                ) : (
                  <Typography>-</Typography>
                )}
              </CustomLabeled>
            )}
          />
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Reference Number">
            <TextField source="referenceNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Contact Details
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Contact">
            <TextField source="contactNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Email">
            <TextField source="email" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={6}>
          <CustomLabeled name="Address">
            <TextField source="address" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Block/No.">
            <TextField source="blockNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Unit No.">
            <TextField source="unitNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Postal Code">
            <TextField source="postalCode" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Document Details
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <ArrayField source="documents" fieldKey="id">
            <Datagrid
              empty={<Typography variant="body2">No Result found</Typography>}
            >
              <TextField source="type" emptyText="-" />
              <TextField source="drivingLicenseClass" emptyText="-" />
              <TextField source="serialNumber" emptyText="-" />
              <CustomDateField source="expiryDate" />
              <UrlField source="fileUrl" emptyText="-" />
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={6}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
